import { store } from '@redux/store';
import GoogleAnalyticsEvent from 'dataTransferObjects/googleAnalyticsEvent';
import uiStateSlice from 'layout/redux/uiStateSlice';
import modalService from 'layout/services/modalService';
import { closeModalSvg, thanksContentSvg } from '../constants/svgIcons';
import DetailsAnchor from './detailsAnchor';

export default class ThankScreenAskQuestion {
  constructor() {
    const state = store.getState();
    const modalInformation = state?.uiState?.modalInformation;
    const listingInformation = modalInformation?.listingInformation;
    this.url = modalInformation?.url;
    this.builderName = listingInformation?.brandName ?? 'the builder';
    this.marketId = listingInformation?.marketId;
    this.closeAttribute = '[data-close]';
    this.moreDetailsAnchor = new DetailsAnchor();
    this.moreDetailsAnchor.setUrl(this.url);
    this.moreDetailsAnchor.setListingId(listingInformation.id);
    this.moreDetailsAnchor.setListingType(listingInformation.type);
  }

  emitMoreDetailsClickEvent() {
    const googleAnalyticsDTO = new GoogleAnalyticsEvent('Card-Clicks', 'SRP-Card-Clicks', this.url);
    store.dispatch(uiStateSlice.actions.trackUserEvent({ googleAnalyticsDTO }));
  }

  bindEvents() {
    const closeElements = document.querySelectorAll(this.closeAttribute);
    closeElements.forEach((element) => element.addEventListener('click', ThankScreenAskQuestion.closeModal));

    const detailsLink = this.moreDetailsAnchor.getAnchor();
    // if the anchor element contains any events, bind them here.
    this.moreDetailsAnchor.bindEvents();
    detailsLink.addEventListener('click', this.emitMoreDetailsClickEvent.bind(this));
  }

  unbindEvents() {
    const detailsLink = this.moreDetailsAnchor.getAnchor();
    detailsLink.removeEventListener('click', this.emitMoreDetailsClickEvent);
  }

  static closeModal() {
    modalService.clearHtml();
  }

  getHtml() {
    return `
    <div class="lead-form form--thanks">
      <button class="modal__close" data-close>
        ${closeModalSvg}          
      </button>
      <div class="thanks__content">
        ${thanksContentSvg}
        <p class="thanks__title">Thank You!</p>
        <p class="thanks__subtitle">${this.builderName} will reach out to you soon with an answer.</p>
      </div>
      <div class="form__button-bar">
        <button class="btn btn--white btn--48-lg" data-close>
          Return to Search
        </button>
        ${this.moreDetailsAnchor.getHtml()}
      </div>
    </div>`;
  }
}
